import { useEffect, useRef } from 'react';

/** Calls `fn` immediately and every `ms` while `active` is true. `fn` may be async; overlapping calls are skipped. */
export default function usePolling(fn, ms, active) {
  const busy = useRef(false);
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => {
    if (!active) return undefined;
    let alive = true;
    const tick = async () => {
      if (busy.current) return;
      busy.current = true;
      try { await fnRef.current(); } finally { busy.current = false; }
    };
    tick();
    const id = setInterval(() => { if (alive) tick(); }, ms);
    return () => { alive = false; clearInterval(id); };
  }, [ms, active]);
}
